import { ChangeDetectorRef, Component, ElementRef, Inject, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { DatePipe, formatDate } from '@angular/common';
import { SharedServiceService } from 'src/app/common/shared-service.service';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-fatigue',
  templateUrl: './fatigue.component.html',
  styleUrls: ['./fatigue.component.scss']
})
export class FatigueComponent implements OnInit {

  httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  ipServer: string = "https://api.medilifewellness.com:2443";
  // ipServer: string = "https://localhost:44378";


  imeiList: any[] = [];

  dataChartFatigue: any[] = [];
  dataCalculateFatigue: any[] = [];
  dataChart24List: any[] = [];
  dataChart7DayList: any[] = [];
  countChartData = 1;


  dataChart24List_Day1: any[] = [];
  dataCalculateFatigue_Day1: any[] = [];


  filterEmtyData: any[] = [];
  datetimeShowList: any[] = [];


  minFatigueValue: any = 0;
  maxFatigueValue: any = 0;
  averFatigueValue: any = 0;

  countGood: any = 0;
  countMid: any = 0;
  countBad: any = 0;

  gimeiCode: any = "";

  rangeDateStartAndEnd = new FormGroup({
    start: new FormControl(new Date()),
    end: new FormControl(new Date()),
  });
  setNow: any = new Date();

  @ViewChild('chartFatigue', { static: false }) chartFatigue!: ElementRef;
  @ViewChild('chartFatigueColl', { static: false }) chartFatigueColl!: ElementRef;
  @ViewChild('chartFatigueAver24Line', { static: false }) chartFatigueAver24Line!: ElementRef;

  @ViewChild('chartFatigueAver7day', { static: false }) chartFatigueAver7day!: ElementRef;

  @ViewChild('chartFatigueValPercen', { static: false }) chartFatigueValPercen!: ElementRef;

  constructor(private httpClient: HttpClient, private datePipe: DatePipe, private sharedServiceService: SharedServiceService,@Inject(LOCALE_ID) private locale: string,private changeDetectRef:ChangeDetectorRef,) {

  }


  ngOnInit(): void {
    // this.loadIMEIListData();
    this.sharedServiceService.deviceIDValue.subscribe(
      (swimei) => {
        // console.log("message ID ", message);
        var now = new Date();

        var nowStart = formatDate(now, 'yyyy-MM-dd', this.locale);
        var nowEnd = formatDate(now.setDate(now.getDate() + 1), 'yyyy-MM-dd', this.locale);
        this.loadDataChart(swimei, nowStart, nowEnd);
        let dateNow = this.datePipe.transform(new Date(), "yyyy-MM-dd");
        setTimeout(async () => {
          await this.onChangeDateTimeEvent(dateNow, true);
        }, 1500);
      }
    );
  }

  onChangeDate() {
    var dataStart: string = '';
    var dataEnd: string = '';

    dataStart = this.rangeDateStartAndEnd.value.start;
    dataEnd = this.rangeDateStartAndEnd.value.end;

    if (this.rangeDateStartAndEnd.value.start != null && this.rangeDateStartAndEnd.value.end != null) {
      var dataStart_ = formatDate(dataStart, 'yyyy-MM-dd', this.locale);
      var dataEnd_ = formatDate(dataEnd, 'yyyy-MM-dd', this.locale);

      var newEnd = new Date(dataEnd);
      var newEndAddDay = newEnd.setDate(newEnd.getDate() + 1);
      dataEnd_ = formatDate(newEndAddDay, 'yyyy-MM-dd', this.locale);
      console.log("dataStart_ ", dataStart_, " | dataEnd_ ", dataEnd_);

      this.loadDataChart(this.gimeiCode, dataStart_, dataEnd_);
    }
  }

  loadIMEIListFormAPI() {
    return new Promise((resolve, reject) => {
      let API_URL = `${this.ipServer}/api/smartwatch_cn_api/getCN_Fatigue_CollectionList`;
      this.httpClient.get(API_URL, { headers: this.httpHeaders, responseType: "json" }).subscribe(data => {
        resolve(data);
      },
        error => {
          reject(error);
        });
    });
  }

  async loadIMEIListData() {
    await this.loadIMEIListFormAPI().then(
      (res: any) => {
        console.log(res);
        this.imeiList = res;
      },
      (error) => {
        console.log(error.status + ' ' + error.statusText);
      })
  }

  loadChartFormAPI(imeiCode: string, dateStart: string, dateEnd: string) {
    return new Promise((resolve, reject) => {
      let API_URL = `${this.ipServer}/api/smartwatch_cn_api/getCN_LogFatigueDateFilterList?imeicode=${imeiCode}&dateStart=${dateStart}&dateEnd=${dateEnd}`;
      this.httpClient.get(API_URL, { headers: this.httpHeaders, responseType: "json" }).subscribe(data => {
        resolve(data);
      },
        error => {
          reject(error);
        });
    });
  }


  async loadDataChart(imeiCode: string, dateStart: string, dateEnd: string) {
    await this.loadChartFormAPI(imeiCode, dateStart, dateEnd).then(
      (resq: any) => {
        // this.countChartData = 1;

        console.log("resq -------------> ", resq);
        this.countChartData = resq.length;
        this.changeDetectRef.detectChanges();

        var res = [];

        this.filterEmtyData = [];
        this.datetimeShowList = [];


        this.gimeiCode = imeiCode;
        this.dataCalculateFatigue = [];
        this.dataChartFatigue = [];
        this.dataChart24List = [];
        this.dataChart7DayList = [];
        this.minFatigueValue = 0;
        this.maxFatigueValue = 0;
        this.averFatigueValue = 0;



        this.countGood = 0;
        this.countBad = 0;
        this.countMid = 0;




        for (var i = 0; i < resq.length; i++) {
          if (resq[i].fatigue_val > 0) {
            res.push({
              id: resq[i].id,
              imeicode: resq[i].imeicode,
              fatigue_val: resq[i].fatigue_val,
              fatigue_status: resq[i].fatigue_status,
              time_log: resq[i].time_log
            });
          }
        }

        console.log("res -------------> ", res);



        // res.sort(function (a: any, b: any) {
        //   return + new Date(a.time_log) - + new Date(b.time_log);
        // });


        for (let i = 0; i < res.length; i++) {
          this.dataChartFatigue.push({
            // date: formatDate(
            //   res[i].time_log,
            //   'yyyy/MM/dd hh:mm',
            //   'en-US'
            // ),
        date: res[i].time_log.split("T")[0]+" "+res[i].time_log.split("T")[1].substring(0,5),

            dateformat: new Date(formatDate(
              res[i].time_log,
              'yyyy/MM/dd',
              'en-US'
            )).toLocaleDateString('en-US'),
            value1: Number(res[i].fatigue_val),
            value2: res[i].fatigue_status,
          });

          this.dataCalculateFatigue.push({
            date: new Date(res[i].time_log),
            time_h: new Date(formatDate(res[i].time_log, 'yyyy/MM/dd HH:MM', 'en-US')).getHours(),
            time_day: new Date(formatDate(res[i].time_log, 'yyyy/MM/dd HH:MM', 'en-US')).getDay(),
            value1: Number(res[i].fatigue_val),
            value2: res[i].fatigue_status,
          });

        }
        this.dataCalculateFatigue = this.dataCalculateFatigue.map((item: any) => ({
          ...item,
          date: new Date(new Date(item.date).getTime() - (1000 * 60 * 60 * 7)),
          time_h: item.time_h - 7
        }));

        this.dataChartFatigue.sort(function (a: any, b: any) {
          return + new Date(a.date) - + new Date(b.date);
        });

        for (var i = 0; i < this.dataChartFatigue.length; i++) {
          if (this.dataChartFatigue[i].value1 != 0 && this.dataChartFatigue[i].value1 != NaN) {
            this.filterEmtyData.push({
              dateformat: this.dataChartFatigue[i].dateformat
            });
          }
        }

        // Group DateTime For เลือกแบบวัน
        let group = this.filterEmtyData.reduce((r, a) => {
          r[a.dateformat] = [...r[a.dateformat] || [], a];
          return r;
        }, {});
        const result_group = Object.keys(group).map(function (k) {
          const item = group[k];
          return {
            datetxtShow: item[0].dateformat
          }
        });

        this.datetimeShowList = result_group;
        // console.log("Group datetimeShowList ", this.datetimeShowList);











        // ---------------------------------------- หา min max หาเฉลี่ย
        if(this.dataCalculateFatigue.length > 0){
        this.minFatigueValue = Math.min.apply(Math, this.dataCalculateFatigue.map(function (o) { return o.value1; }));
        this.maxFatigueValue = Math.max.apply(Math, this.dataCalculateFatigue.map(function (o) { return o.value1; }));
        var total = 0;
        for (var i = 0; i < this.dataCalculateFatigue.length; i++) {
          total += this.dataCalculateFatigue[i].value1;
        }
        this.averFatigueValue = total / this.dataCalculateFatigue.length;
      }



        // หา 24 ชม. เฉลี่ย --------------------------- เอาตัวเลข time_h มา Group
        const reduced = this.dataCalculateFatigue.reduce(function (m, d) {
          if (!m[d.time_h]) {
            m[d.time_h] = { ...d, count: 1 };
            return m;
          }
          m[d.time_h].value1 += d.value1;
          m[d.time_h].count += 1;
          return m;
        }, {});



        // หาค่าเฉลี่ย
        const result = Object.keys(reduced).map(function (k) {
          const item = reduced[k];
          return {
            time_h: item.time_h,
            avg: item.value1 / item.count,
          }
        });



        // โชว์ค่าทั้ง 24 ชั่วโมง
        for (var i = 0; i < 24; i++) {
          var index = result.findIndex(e => e.time_h == i);
          if (index > -1) {
            this.dataChart24List.push({
              time_h: ("00" + result[index].time_h).slice(-2) + ":00 น",
              avg: result[index].avg,
              num_hr: result[index].time_h
            });
          } else {
            this.dataChart24List.push({
              time_h: ("00" + i).slice(-2) + ":00 น",
              avg: 0,
              num_hr: i
            });
          }
        }

        console.log("dataChart24List AveAll", this.dataChart24List);


        // --------------------------------- หาผล min กี่ครั้ง , max กี่ครั้ง
        if(this.dataCalculateFatigue.length > 0){
        for (var i = 0; i < this.dataCalculateFatigue.length; i++) {
          if (this.dataCalculateFatigue[i].value2 == "good") {
            this.countGood++;
          } else if (this.dataCalculateFatigue[i].value2 == "middle") {
            this.countMid++;
          } else {
            this.countBad++;
          }
        }
      }




        // หา 7 วันเฉลี่ย --------------------- เอาตัวเลข time_day มา Group
        const reduced_day = this.dataCalculateFatigue.reduce(function (m, d) {
          if (!m[d.time_day]) {
            m[d.time_day] = { ...d, count: 1 };
            return m;
          }
          m[d.time_day].value1 += d.value1;
          m[d.time_day].count += 1;
          return m;
        }, {});

        // หาค่าเฉลี่ย
        const result_day = Object.keys(reduced_day).map(function (k) {
          const item = reduced_day[k];

          var daynames = "";

          switch (item.time_day) {
            case 0:
              daynames = "วันอาทิตย์";
              break;
            case 1:
              daynames = "วันจันทร์";
              break;
            case 2:
              daynames = "วันอังคาร";
              break;
            case 3:
              daynames = "วันพุธ";
              break;
            case 4:
              daynames = "วันพฤหัส";
              break;
            case 5:
              daynames = "วันศุกร์";
              break;
            default:
              daynames = "วันเสาร์";
              break;
          }

          return {
            time_day: daynames,
            avg: item.value1 / item.count,
          }
        });

        this.dataChart7DayList = result_day;





        // GEN กราฟ
        this.GraphFatigueDemo();
        this.GraphFatigueCollDemo();

        this.GraphAver24hLine(this.dataChart24List);
        this.GraphAver7days();
        this.GraphValPercen();

      },
      (error) => {
        console.log(error.status + ' ' + error.statusText);
      })
  }


  loadChartbyDateFormAPI(imeiCode: string, datetimes: string) {
    return new Promise((resolve, reject) => {
      let API_URL = `${this.ipServer}/api/smartwatch_cn_api/getCN_DayFatigue?imeicode=${imeiCode}&date=${datetimes}`;
      this.httpClient.get(API_URL, { headers: this.httpHeaders, responseType: "json" }).subscribe(data => {
        resolve(data);
      },
        error => {
          reject(error);
        });
    });
  }



  async loadDatabyDateChart(imeiCode: string, datetimes: string) {
    await this.loadChartbyDateFormAPI(imeiCode, datetimes).then(
      (res: any) => {

        this.dataChart24List_Day1 = [];
        this.dataCalculateFatigue_Day1 = [];

        for (let i = 0; i < res.length; i++) {
          this.dataCalculateFatigue_Day1.push({
            date: new Date(res[i].time_log),
            time_h: new Date(formatDate(res[i].time_log, 'yyyy/MM/dd HH:MM', 'en-US')).getHours(),
            time_day: new Date(formatDate(res[i].time_log, 'yyyy/MM/dd HH:MM', 'en-US')).getDay(),
            value1: Number(res[i].fatigue_val),
            value2: res[i].fatigue_status,
          });
        }
        this.dataCalculateFatigue_Day1 = this.dataCalculateFatigue_Day1.map((item: any) => ({
          ...item,
          date: new Date(new Date(item.date).getTime() - (1000 * 60 * 60 * 7)),
          time_h: item.time_h - 7
        }));

        const reduced = this.dataCalculateFatigue_Day1.reduce(function (m, d) {
          if (!m[d.time_h]) {
            m[d.time_h] = { ...d, count: 1 };
            return m;
          }
          m[d.time_h].value1 += d.value1;
          m[d.time_h].count += 1;
          return m;
        }, {});

        const result = Object.keys(reduced).map(function (k) {
          const item = reduced[k];
          return {
            time_h: item.time_h,
            avg: item.value1 / item.count,
          }
        });


        // โชว์ค่าทั้ง 24 ชั่วโมง
        for (var i = 0; i < 24; i++) {
          var index = result.findIndex(e => e.time_h == i);
          if (index > -1) {
            this.dataChart24List_Day1.push({
              time_h: ("00" + result[index].time_h).slice(-2) + ":00 น",
              avg: result[index].avg,
              num_hr: result[index].time_h
            });
          } else {
            this.dataChart24List_Day1.push({
              time_h: ("00" + i).slice(-2) + ":00 น",
              avg: 0,
              num_hr: i
            });
          }
        }

        this.GraphAver24hLine(this.dataChart24List_Day1);

      },
      (error) => {
        console.log(error.status + ' ' + error.statusText);
      })
  }


  GraphFatigueDemo() {
this.changeDetectRef.detectChanges();
    am4core.useTheme(am4themes_animated);

    // Create chart instance
    var chart = am4core.create(this.chartFatigue.nativeElement, am4charts.XYChart);
    chart.exporting.menu = new am4core.ExportMenu();
    this.dataChartFatigue = this.dataChartFatigue.map((item: any) => ({
      ...item,
      date: this.datePipe.transform(item.date, "dd-MM-yyyy H:mm")
    }));
    chart.data = this.dataChartFatigue;

    let gradient = new am4core.LinearGradient();
    gradient.addColor(am4core.color("#243b55"));
    gradient.addColor(am4core.color("#141e30"));
    gradient.rotation = 90;
    chart.background.fill = gradient;


    // Create axes
    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'date';
    categoryAxis.renderer.minGridDistance = 30;
    categoryAxis.renderer.labels.template.rotation = 300;
    categoryAxis.renderer.grid.template.stroke = am4core.color("#ffffff");
    categoryAxis.renderer.labels.template.fill = am4core.color("#ffffff");

    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.max = 100;
    valueAxis.renderer.grid.template.stroke = am4core.color("#ffffff");
    valueAxis.renderer.labels.template.fill = am4core.color("#ffffff");



    // Create series
    var series = chart.series.push(new am4charts.LineSeries());
    series.dataFields.valueY = 'value1';
    series.dataFields.categoryX = 'date';
    series.strokeWidth = 1;
    series.minBulletDistance = 10;
    series.stroke = am4core.color('#64dbfb');
    series.tooltipText = '[bold]{date}:[/] {value1}\n[bold]';



    var axisRangegood = valueAxis.axisRanges.create();
    axisRangegood.value = 50;
    axisRangegood.grid.strokeOpacity = 1;
    axisRangegood.grid.stroke = am4core.color('#00ba00');
    axisRangegood.grid.strokeWidth = 1;

    var axisRangebad = valueAxis.axisRanges.create();
    axisRangebad.value = 25;
    axisRangebad.grid.strokeOpacity = 1;
    axisRangebad.grid.stroke = am4core.color('#f3260e');
    axisRangebad.grid.strokeWidth = 1;

    var rangeareamid = valueAxis.axisRanges.create();
    rangeareamid.value = 25;
    rangeareamid.endValue = 50;
    rangeareamid.axisFill.fill = am4core.color('#fcff01');
    rangeareamid.axisFill.fillOpacity = 0.2;
    rangeareamid.grid.strokeOpacity = 0;

    var rangeareagood = valueAxis.axisRanges.create();
    rangeareagood.value = 50;
    rangeareagood.endValue = 100;
    rangeareagood.axisFill.fill = am4core.color('#00ba00');
    rangeareagood.axisFill.fillOpacity = 0.2;
    rangeareagood.grid.strokeOpacity = 0;

    var rangeareabad = valueAxis.axisRanges.create();
    rangeareabad.value = 0;
    rangeareabad.endValue = 25;
    rangeareabad.axisFill.fill = am4core.color('#f3260e');
    rangeareabad.axisFill.fillOpacity = 0.2;
    rangeareabad.grid.strokeOpacity = 0;

    // var rangeareabottom = valueAxis.axisRanges.create();
    // rangeareabottom.value = 88;
    // rangeareabottom.endValue = 90;
    // rangeareabottom.axisFill.fill = am4core.color('#f3260e');
    // rangeareabottom.axisFill.fillOpacity = 0.2;
    // rangeareabottom.grid.strokeOpacity = 0;

    // Add cursor
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.xAxis = categoryAxis;
  }




  GraphFatigueCollDemo() {

    var newColor = [];

    am4core.useTheme(am4themes_animated);

    var chart = am4core.create(this.chartFatigueColl.nativeElement, am4charts.XYChart);
    chart.exporting.menu = new am4core.ExportMenu();

    let gradient = new am4core.LinearGradient();
    gradient.addColor(am4core.color("#243b55"));
    gradient.addColor(am4core.color("#141e30"));
    gradient.rotation = 90;
    chart.background.fill = gradient;

    for (var i = 0; i < this.dataChartFatigue.length; i++) {
      if (this.dataChartFatigue[i].value1 > 50) {
        newColor.push({
          date: this.dataChartFatigue[i].date,
          dateformat: this.dataChartFatigue[i].dateformat,
          value1: this.dataChartFatigue[i].value1,
          "color": am4core.color("#00ba00")
        })
      } else if (this.dataChartFatigue[i].value1 >= 25 && this.dataChartFatigue[i].value1 <= 50) {
        newColor.push({
          date: this.dataChartFatigue[i].date,
          dateformat: this.dataChartFatigue[i].dateformat,
          value1: this.dataChartFatigue[i].value1,
          "color": am4core.color("#ffab00")
        })
      } else {
        newColor.push({
          date: this.dataChartFatigue[i].date,
          dateformat: this.dataChartFatigue[i].dateformat,
          value1: this.dataChartFatigue[i].value1,
          "color": am4core.color("#ff0000")
        })
      }
    }

    chart.data = newColor;

    // Create axes
    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'date';
    categoryAxis.renderer.minGridDistance = 30;
    categoryAxis.renderer.labels.template.rotation = 300;
    categoryAxis.renderer.grid.template.stroke = am4core.color("#ffffff");
    categoryAxis.renderer.labels.template.fill = am4core.color("#ffffff");

    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    // valueAxis.min = 70;
    valueAxis.renderer.grid.template.stroke = am4core.color("#ffffff");
    valueAxis.renderer.labels.template.fill = am4core.color("#ffffff");

    var series = chart.series.push(new am4charts.ColumnSeries());
    series.sequencedInterpolation = true;
    series.dataFields.valueY = "value1";
    series.dataFields.categoryX = "date";
    series.tooltipText = "[bold]{date}:[/] {value1}\n[bold]";
    series.columns.template.strokeWidth = 0;
    series.columns.template.column.cornerRadiusTopLeft = 10;
    series.columns.template.column.cornerRadiusTopRight = 10;
    series.columns.template.column.fillOpacity = 0.8;
    series.columns.template.propertyFields.fill = "color";
    series.tooltipPosition = "pointer";

    // Add cursor
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.xAxis = categoryAxis;
  }



  GraphAver24hLine(mainData: any[]) {

    am4core.useTheme(am4themes_animated);

    var chart = am4core.create(this.chartFatigueAver24Line.nativeElement, am4charts.XYChart);
    chart.exporting.menu = new am4core.ExportMenu();

    let gradient = new am4core.LinearGradient();
    gradient.addColor(am4core.color("#243b55"));
    gradient.addColor(am4core.color("#141e30"));
    gradient.rotation = 90;
    chart.background.fill = gradient;

    let newList: any = [];

    for (var i = 0; i < mainData.length; i++) {
      newList.push({
        time_h: mainData[i].time_h,
        avg: mainData[i].avg,
        num_hr: i
      })
    }

    chart.data = newList;

    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "time_h";
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 30;
    categoryAxis.renderer.labels.template.horizontalCenter = "right";
    categoryAxis.renderer.labels.template.verticalCenter = "middle";
    categoryAxis.renderer.labels.template.rotation = 270;
    categoryAxis.renderer.minHeight = 110;
    categoryAxis.renderer.grid.template.stroke = am4core.color("#ffffff");
    categoryAxis.renderer.labels.template.fill = am4core.color("#ffffff");

    let dateAxis2 = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis2.renderer.grid.template.location = 0;
    dateAxis2.renderer.minGridDistance = 40;
    dateAxis2.renderer.labels.template.disabled = true;
    dateAxis2.renderer.grid.template.disabled = true;
    dateAxis2.cursorTooltipEnabled = false;

    let valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis2.renderer.grid.template.stroke = am4core.color("#ffffff");
    valueAxis2.renderer.labels.template.fill = am4core.color("#ffffff");
    valueAxis2.min = 0;
    valueAxis2.max = 60;

    var axisRangegood = valueAxis2.axisRanges.create();
    axisRangegood.value = 50;
    axisRangegood.grid.strokeOpacity = 1;
    axisRangegood.grid.stroke = am4core.color('#00ba00');
    axisRangegood.grid.strokeWidth = 1;

    var axisRangebad = valueAxis2.axisRanges.create();
    axisRangebad.value = 25;
    axisRangebad.grid.strokeOpacity = 1;
    axisRangebad.grid.stroke = am4core.color('#f3260e');
    axisRangebad.grid.strokeWidth = 1;

    var rangeareamid = valueAxis2.axisRanges.create();
    rangeareamid.value = 50;
    rangeareamid.endValue = 25;
    rangeareamid.axisFill.fill = am4core.color('#fcff01');
    rangeareamid.axisFill.fillOpacity = 0.2;
    rangeareamid.grid.strokeOpacity = 0;

    var rangeareagood = valueAxis2.axisRanges.create();
    rangeareagood.value = 50;
    rangeareagood.endValue = 100;
    rangeareagood.axisFill.fill = am4core.color('#00ba00');
    rangeareagood.axisFill.fillOpacity = 0.2;
    rangeareagood.grid.strokeOpacity = 0;

    var rangeareabad = valueAxis2.axisRanges.create();
    rangeareabad.value = 0;
    rangeareabad.endValue = 25;
    rangeareabad.axisFill.fill = am4core.color('#f3260e');
    rangeareabad.axisFill.fillOpacity = 0.2;
    rangeareabad.grid.strokeOpacity = 0;

    let series2 = chart.series.push(new am4charts.LineSeries());
    series2.dataFields.valueY = "avg";
    series2.dataFields.dateX = "num_hr";
    series2.data = this.dataChart24List;
    series2.xAxis = dateAxis2;
    series2.yAxis = valueAxis2;
    series2.strokeWidth = 3;
    series2.tooltipText = "Average : [bold]{valueY.formatNumber('#.00')}[/]%";
    series2.stroke = am4core.color('#cd0506');
    series2.fill = am4core.color('#cd0506');


    let series1 = chart.series.push(new am4charts.LineSeries());
    series1.dataFields.valueY = "avg";
    series1.dataFields.dateX = "num_hr";
    series1.data = newList;
    series1.xAxis = dateAxis2;
    series1.yAxis = valueAxis2;
    series1.strokeWidth = 2;
    series1.tooltipText = "ปัจจุบัน [bold]{valueY.formatNumber('#.00')}[/]%";
    series1.stroke = am4core.color('#00bce6');
    series1.fill = am4core.color('#00bce6');


    // Add cursor
    chart.cursor = new am4charts.XYCursor();

  }




  async loadDatabyDateChartAndReturn(datetimes: string) {

    var objList: any = [];

    await this.loadChartbyDateFormAPI(this.gimeiCode, datetimes).then(
      (res: any) => {

        var List_Day1: any = [];
        var Fatigue_Day1: any = [];

        for (let i = 0; i < res.length; i++) {
          Fatigue_Day1.push({
            date: new Date(res[i].time_log),
            time_h: new Date(formatDate(res[i].time_log, 'yyyy/MM/dd HH:MM', 'en-US')).getHours(),
            time_day: new Date(formatDate(res[i].time_log, 'yyyy/MM/dd HH:MM', 'en-US')).getDay(),
            value1: Number(res[i].steress_val),
            value2: res[i].Fatigue_status,
          });
        }

        const reduced = Fatigue_Day1.reduce(function (m: any, d: any) {
          if (!m[d.time_h]) {
            m[d.time_h] = { ...d, count: 1 };
            return m;
          }
          m[d.time_h].value1 += d.value1;
          m[d.time_h].count += 1;
          return m;
        }, {});

        const result = Object.keys(reduced).map(function (k) {
          const item = reduced[k];
          return {
            time_h: item.time_h,
            avg: item.value1 / item.count,
          }
        });


        // โชว์ค่าทั้ง 24 ชั่วโมง
        for (var i = 0; i < 24; i++) {
          var index = result.findIndex(e => e.time_h == i);
          if (index > -1) {
            List_Day1.push({
              time_h: ("00" + result[index].time_h).slice(-2) + ":00 น",
              avg: result[index].avg,
              num_hr: result[index].time_h
            });
          } else {
            List_Day1.push({
              time_h: ("00" + i).slice(-2) + ":00 น",
              avg: 0,
              num_hr: i
            });
          }
        }


        objList.push({
          time_day: datetimes,
          data_list: List_Day1
        });

      },
      (error) => {
        console.log(error.status + ' ' + error.statusText);
      });

    return objList;

  }



  GraphAver7days() {

    am4core.useTheme(am4themes_animated);
    // Themes end

    var chart = am4core.create(this.chartFatigueAver7day.nativeElement, am4charts.XYChart);
    chart.exporting.menu = new am4core.ExportMenu();

    // Add data
    chart.data = this.dataChart7DayList;

    // Create axes
    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "time_day";
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 30;
    categoryAxis.renderer.labels.template.horizontalCenter = "right";
    categoryAxis.renderer.labels.template.verticalCenter = "middle";
    categoryAxis.renderer.labels.template.rotation = 270;
    categoryAxis.renderer.minHeight = 110;

    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.minWidth = 50;

    // Create series
    let series = chart.series.push(new am4charts.ColumnSeries());
    series.sequencedInterpolation = true;
    series.dataFields.valueY = "avg";
    series.dataFields.categoryX = "time_day";
    series.tooltipText = "[{categoryX}: bold]{valueY.formatNumber('#.00')}[/]";
    series.columns.template.strokeWidth = 0;
    series.columns.template.column.cornerRadiusTopLeft = 10;
    series.columns.template.column.cornerRadiusTopRight = 10;
    series.columns.template.column.fillOpacity = 0.8;
    series.fill = am4core.color("#514ab8");

    // on hover, make corner radiuses bigger
    let hoverState = series.columns.template.column.states.create("hover");
    hoverState.properties.cornerRadiusTopLeft = 0;
    hoverState.properties.cornerRadiusTopRight = 0;
    hoverState.properties.fillOpacity = 1;

    // Cursor
    chart.cursor = new am4charts.XYCursor();
  }





  GraphValPercen() {

    var val1 = (this.countGood / this.dataChartFatigue.length) * 100;
    var val2 = (this.countMid / this.dataChartFatigue.length) * 100;
    var val3 = (this.countBad / this.dataChartFatigue.length) * 100;

    am4core.useTheme(am4themes_animated);
    // Themes end

    var chart = am4core.create(this.chartFatigueValPercen.nativeElement, am4charts.XYChart);
    chart.exporting.menu = new am4core.ExportMenu();

    chart.data = [{
      "country": "ปกติ (มากกว่า 50)",
      "visits": val1.toFixed(2),
      "color": am4core.color("#00ba00")
    }, {
      "country": "ปานกลาง (25 - 50)",
      "visits": val2.toFixed(2),
      "color": am4core.color("#ffb600")
    }, {
      "country": "สูง (น้อยกว่า 25)",
      "visits": val3.toFixed(2),
      "color": am4core.color("#bb3a03")
    }];

    //create category axis for years
    let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "country";
    categoryAxis.renderer.inversed = true;
    categoryAxis.renderer.grid.template.location = 0;

    //create value axis for income and expenses
    let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.opposite = true;

    //create columns
    let series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.categoryY = "country";
    series.dataFields.valueX = "visits";
    series.name = "Fatigue";
    series.columns.template.fillOpacity = 1;
    series.columns.template.strokeOpacity = 0;
    series.tooltipText = "{categoryY} : {valueX.value.formatNumber('#.00')}%";
    series.columns.template.propertyFields.fill = "color";

    //add chart cursor
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.behavior = "zoomY";

  }



  onChangeDateTimeEvent(event: any, isFirst: boolean) {
    if (!isFirst) var datetimeStr = formatDate(event.value, 'yyyy-MM-dd', 'en-US').toString();
    else var datetimeStr = formatDate(event, 'yyyy-MM-dd', 'en-US').toString();
    this.loadDatabyDateChart(this.gimeiCode, datetimeStr);
  }

}
